import {Button, styled} from '@mui/material';

const StyledButton = styled(Button)`
	${({theme}) => theme.breakpoints.down('sm')} {
		padding: 12px 16px;
	}
	border-radius: 0;
`;

export {StyledButton};
